/**
 * Feature 100 — admin read of /partner-trial requests (grant-flow prefill).
 */

import { apiClient } from '@/core/api/client';

export type AdminTrialRequest = {
  id: string;
  firstName: string;
  lastName: string;
  businessEmail: string;
  companyName: string;
  jobTitle: string;
  phoneNumber: string | null;
  firmWebsite: string | null;
  hearAbout: string;
  existingAccountId: string | null;
  linkedAdvisorId: string | null;
  createdAt: string;
};

export async function getTrialRequest(id: string): Promise<AdminTrialRequest> {
  const response = await apiClient.get<AdminTrialRequest>(`/admin/trial-requests/${id}`);
  return response.data;
}
